/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/emailVerificationMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a EmailVerification. */
export class EmailVerification {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a EmailVerification.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls the VerificationClient API to generate a security code and sends it to the email address.
   * @summary Generates a security code that is sent to the email address.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  generateCode(options?: Models.EmailVerificationGenerateCodeOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  generateCode(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  generateCode(options: Models.EmailVerificationGenerateCodeOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  generateCode(options?: Models.EmailVerificationGenerateCodeOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      generateCodeOperationSpec,
      callback);
  }

  /**
   * Calls the VerificationClient to verify the security code of the email address.
   * @summary Verifies the security code for the email address.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  verifyCode(options?: Models.EmailVerificationVerifyCodeOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  verifyCode(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  verifyCode(options: Models.EmailVerificationVerifyCodeOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  verifyCode(options?: Models.EmailVerificationVerifyCodeOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      verifyCodeOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const generateCodeOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/me/IdentityTheftMonitoring/email/code",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: {
      serializedName: "body",
      type: {
        name: "String"
      }
    }
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const verifyCodeOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/me/IdentityTheftMonitoring/email/verify",
  queryParameters: [
    Parameters.updateExternal
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.EmailVerificationCodeRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
